import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { API, useAuth } from "../App";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleAuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [params] = useSearchParams();
  const processed = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const code = params.get("code");
    const state = params.get("state");
    const errParam = params.get("error");
    if (errParam) { setErr(errParam); setTimeout(() => navigate("/", { replace: true }), 2500); return; }
    if (!code || !state) { navigate("/", { replace: true }); return; }
    const redirect_uri = `${window.location.origin}/auth/google`;
    (async () => {
      try {
        await axios.get(`${API}/auth/google/callback`, { params: { code, state, redirect_uri }, withCredentials: true });
        try {
          const ref = localStorage.getItem("petbond_ref");
          if (ref) {
            try { await axios.post(`${API}/referrals/claim`, { code: ref }); } catch {}
            localStorage.removeItem("petbond_ref");
          }
        } catch {}
        await refresh();
        let next = "/app";
        try {
          const intent = localStorage.getItem("petbond_post_signin");
          if (intent) { localStorage.removeItem("petbond_post_signin"); next = intent; }
        } catch {}
        navigate(next, { replace: true });
      } catch (e) {
        setErr(e?.response?.data?.detail || "Sign-in failed");
        setTimeout(() => navigate("/", { replace: true }), 2500);
      }
    })();
  }, [params, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FFFDF7]" data-testid="google-auth-callback">
      <div className="text-center">
        <img src="/brand/petbond-logo-192.png" alt="PetBond" className="h-16 w-auto mx-auto mb-4 rounded-2xl"/>
        <div className="w-12 h-12 rounded-full border-4 border-brand border-t-transparent animate-spin mx-auto mb-4" />
        <div className="font-heading text-xl font-bold">{err ? err : "Welcoming you to PetBond…"}</div>
      </div>
    </div>
  );
}
